import React from 'react';
import css from '../less/index.m.less';
import {DropDown, FieldError, ErrorHint, Preloader, Control, IPeriod, IDate} from '@ab/components';
import {ALL_CATEGORIES} from '../variables';
import List from '../views/list.c';
import computeCategory from '../utils/computeCategory.u';
import {getCurrencySymbol} from '../../../constants/currency';
import DateInput from '../../CustomComponents/dateInput';
import WithClickOutside from '../../../hoc/withClickOutside';

const ALLOWED_DATES = new IPeriod(new IDate('25.02.2005'), 'today');

export default function template() {
    const {
            collection,
            category,
            period,
            dateInput,
            openFilters,
            openCalendar,
            activeFilterId,
        } = this.state,
        model = this.getModel(),
        isProcessing = this.isUiProcessing(),
        list = collection,
        totals = this.getTotals(list),
        filterList = [
            {
                type: 'today',
                name: 'Поточний день',
            },
            {
                type: 'yesterday',
                name: 'Попередній день',
            },
            {
                type: 'currWeek',
                name: 'Поточний тиждень',
            },
            {
                type: 'prevWeek',
                name: 'Попередній тиждень',
            },
            {
                type: 'currMonth',
                name: 'Поточний місяць',
            },
            {
                type: 'prevMonth',
                name: 'Попередній місяць',
            },
            {
                type: 'currQuarter',
                name: 'Поточний квартал',
            },
            {
                type: 'prevQuarter',
                name: 'Попередній квартал',
            },
        ],
        clickToPeriod = (type, e) => {
            this._changeFilterPeriod(type);
            this._setOpenFilters(false);
            this._setActiveFilterId(e.target.id);
        },
        toOpenCalendar = () => {
            this._setOpenCalendar(true);
            dateInput._handleFocus();
            this._setOpenFilters(false);
            this._clearFilters();
        };

    return (
        <div className={css.root}>
            <Control className={css.filter}>
                <WithClickOutside setOpenFilters={this._setOpenFilters}>
                    <div className={css.datepicker}>
                        <DateInput
                            {...this.ctrlProps('period')}
                            className={`${css.dateInput} ${
                                !openCalendar ? css.dateInputDisabled : css.dateInputActive
                            }`}
                            value={this._periodStringify(period)}
                            isPeriod
                            allowedDates={ALLOWED_DATES}
                            disabled={isProcessing}
                            placeholder={this.l10n('STATEMENTS_CALENDAR')}
                            elementRef={this._getDateInput}
                            onFocus={() => {
                                if (!openCalendar) {
                                    this._setOpenFilters(true);
                                    dateInput._handleBlur();
                                } else {
                                    this._setOpenFilters(false);
                                }
                            }}
                            onBlur={() => {
                                this._setOpenCalendar(false);
                            }}
                        />
                        <FieldError error={this.getError('period')} component={ErrorHint} />
                        {openFilters && (
                            <div className={css.list}>
                                <ul>
                                    <li onClick={() => toOpenCalendar()}>
                                        Оберіть період &gt;&gt;
                                    </li>
                                    {filterList.map(({type, name}) => (
                                        <li
                                            id={type}
                                            className={activeFilterId === type ? css.active : ''}
                                            onClick={e =>
                                                activeFilterId !== type
                                                    ? clickToPeriod(type, e)
                                                    : this._setOpenFilters(false)
                                            }
                                            key={type}
                                        >
                                            {name}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        )}
                    </div>
                </WithClickOutside>
                {/* <div className={css.categories}>
                    <DropDown
                        {...this.ctrlProps('category')}
                        className="w-wide"
                        collection={this._getCategoryList()}
                        disabled={isProcessing}
                        placeholder={this.l10n('STATEMENTS_CAT_PLACEHOLDER')}
                    />
                </div>*/}
            </Control>
            {!list.length ? null : (
                <Control className={css.totals}>
                    <div className={css.item}>
                        <span>{this.l10n('STATEMENTS_TOTALS_INCOME')}</span>
                        &nbsp;
                        <b className={css.income}>
                            {totals.income.toFixed(2).toString()}
                            &nbsp;
                            {getCurrencySymbol(parseInt(model.get('currencyCode')))}
                        </b>
                    </div>
                    <div className={css.item}>
                        <span>{this.l10n('STATEMENTS_TOTALS_SPEND')}</span>
                        &nbsp;
                        <b className={css.spend}>
                            {totals.spend.toFixed(2).toString()}
                            &nbsp;
                            {getCurrencySymbol(parseInt(model.get('currencyCode')))}
                        </b>
                    </div>
                </Control>
            )}
            {isProcessing ? (
                <Preloader />
            ) : (
                <div>
                    <List {...this.props} collection={list} card={model} />
                    {list && list.length ? (
                        <button
                            disabled={this.state.isDisabledShowMore}
                            onClick={() => this.showMore()}
                            className={`show-more-button ${
                                this.state.isDisabledShowMore ? 'disabled' : ''
                            }`}
                        >
                            {this.l10n('STATEMENTS_SHOW_MORE_BUTTON')}
                        </button>
                    ) : null}
                </div>
            )}
        </div>
    );
}
